import { createContext, ReactNode, useContext } from 'react';
import { useDashboardStats } from '../hooks/useDashboardStats';

type DashboardStatsContextValue = ReturnType<typeof useDashboardStats>;

// This context is only exported for use in Storybook for injecting mock context values
export const DashboardStatsContext = createContext<DashboardStatsContextValue>(undefined!);

// This context provider is used to wrap the book order modal in the real context values
export function HistoricStatsContextProvider({ projectID, children }: { projectID: string; children: ReactNode }) {
  const context = useDashboardStats(projectID);

  return <DashboardStatsContext.Provider value={context}>{children}</DashboardStatsContext.Provider>;
}

export function useDashboardStatsContext() {
  return useContext(DashboardStatsContext);
}
